module.exports = __webpack_public_path__ + "static/media/talCV.a86ea46b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/talCV.pdf
// module id = 351
// module chunks = 1